import React from 'react';
import { useOptionalFilterState } from '@/hooks/useFilter';
import { useApolloClient } from '@apollo/client';
import {
  CompanyLogoFieldsFragment,
  CompanyLogoFieldsFragmentDoc,
} from '@/generated/codegen';
import { cn } from '@/utils/utils';

export const useCompanyLogoUrl = () => {
  const filter = useOptionalFilterState();
  const { logo_url: companyLogo } =
    useApolloClient().readFragment<CompanyLogoFieldsFragment>({
      id: `Company:${filter.value.company_id}`,
      fragment: CompanyLogoFieldsFragmentDoc,
    }) ?? {};
  return companyLogo;
};

export const CompanyLogo: React.FC<{ className?: string }> = ({
  className,
}) => {
  const companyLogo = useCompanyLogoUrl();
  return companyLogo ? (
    <img
      src={companyLogo}
      alt="logo de la empresa"
      className={cn(className, 'object-cover')}
      crossOrigin="anonymous"
    />
  ) : (
    <></>
  );
};
